const nav = [
  {
    _tag: 'CSidebarNavItem',
    name: 'EQ制御計画',
    to: '/eq-control-plan',
    icon: 'cil-border-all',
    megasolar_include_flag: true,
  },

  {
    _tag: 'CSidebarNavItem',
    name: 'ダウンロード',
    to: '/download',
    icon: 'cil-cloud-download',
    megasolar_include_flag: true,
  },

  {
    _tag: 'CSidebarNavDivider',
    className: 'sed-om-sidebar-divider mt-auto',
    megasolar_include_flag: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'パスワード変更',
    to: '/changePassword',
    icon: 'cil-user',
    megasolar_include_flag: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'ログアウト',
    to: '/logout',
    icon: 'cil-account-logout',
    megasolar_include_flag: true,
  },
  {
    _tag: 'CSidebarNavDivider',
    className: 'm-2',
    megasolar_include_flag: true,
  },
];

export default nav;
